import luxinLanguages from "@/statics/language.js";

luxinLanguages.ge = {
  title: "ქართული",
  short: "ge",
  isRTL: false,
  NODE2_INPUT1_NAME: "შეყვანა 1",
  NODE2_INPUT2_NAME: "შეყვანა 2",
  NODE2_OUTPUT1_NAME: "გამომავალი 1",
  NODE2_OUTPUT2_NAME: "გამომავალი 2",
  NODE3_INPUT1_NAME: "შეყვანა 1",
  NODE3_OUTPUT1_NAME: "გამომავალი 1",
  NODE4_INPUT1_NAME: "შეყვანა 1",
  NODE4_INPUT2_NAME: "შეყვანა 2",
  NODE4_OUTPUT1_NAME: "გამომავალი 1",
  NODE5_INPUT1_NAME: "შეყვანა 1",
  NODE5_OUTPUT1_NAME: "გამომავალი 1",
  NODE6_INPUT1_NAME: "ტემპერატურა",
  NODE6_INPUT2_NAME: "ტენიანობა",
  Hub_Owner: "ადმინ",
  Hub_User: "მომხმარებელი",
  Common_internetError: "გთხოვთ, შეამოწმოთ თქვენი ინტერნეტ კავშირი.",
  Devices_addNewDevice: "მოწყობილობის დამატება",
  BottomNav_dashboard: "დაფა",
  BottomNav_devices: "მოწყობილობები",
  BottomNav_scenarios: "სცენები",
  Devices_Hub_Priviledge: "დაშვების დონე",
  Devices_Hub_IP: "IP მისამართი",
  Devices_Hub_accessOwner: "ადმინ",
  Devices_Hub_accessNormal: "მომხმარებელი",
  Devices_noHubs: "კუბი ვერ მოიძებნა!",
  Devices_noNodes: "ამ ჰაბისთვის მოწყობილობები ვერ მოიძებნა!",
  Device_serachPlaceHolder: "ძებნა ...",
  Devices_searchNotFound: "ვერ იპოვნეს",
  LanguageSelect_selectLanguage: "აირჩიეთ ენა",
  LanguageSelect_submitButton: "შეარჩიეთ",
  LoginRegister_title: "დარეგისტრირდით",
  LoginRegister_text: "გთხოვთ, შეიყვანოთ თქვენი მობილური ნომერი.",
  LoginRegister_button: "გაგზავნის კოდი",
  LoginRegister_placeHolder: "მობილურის ნომერი",
  LoginRegister_back: "უკან",
  LoginRegister_inputError: "არასწორი მობილური ნომერი",
  LoginRegister_serverResponseFail: "რაღაც არასწორია! შეამოწმეთ თქვენი ნომერი და სცადეთ ხელახლა.",
  LoginConfirmationCode_title: "დადასტურების კოდი",
  LoginConfirmationCode_text: "გთხოვთ, შეიყვანოთ თქვენი დადასტურების კოდი.",
  LoginConfirmationCode_failMessage: "ეს არ არის კოდი, რომელიც ჩვენ გამოგიგზავნეთ!",
  LoginConfirmationCode_retry: "ხელახლა გაგზავნა",
  LuxinIntro_Next: "შემდეგი",
  LuxinIntro_Finish: "წავედით",
  IntroSlide1_title: "მოგესალმებით ლუქსინში",
  IntroSlide1_text: "აქედან შეგიძლიათ მარტივად გამოიყენოთ თქვენი Luxin- ის ჭკვიანი სახლი.",
  IntroSlide2_title: "ნივთების ინტერნეტი",
  IntroSlide2_text: "თქვენ შეგიძლიათ მონიტორინგი და აკონტროლოთ თქვენი სახლი ნებისმიერი ადგილიდან, ნებისმიერ დროს!",
  IntroSlide3_title: "ლუქსინ ჰაბი",
  IntroSlide3_text: "პირველ რიგში, თქვენ უნდა დააკავშიროთ ჭკვიანი სახლის ცენტრალურ კონტროლერი.",
  IntroSlide4_title: "დაკავშირება ჰაბთან",
  IntroSlide4_text: "თუ ვინმემ უკვე შექმნა თქვენი ჰაბი, სთხოვეთ მათ წვდომა.",
  AddDevice_title: "მოწყობილობის დამატება",
  AddDevice_text: "თუ თქვენ პირველი არ ხართ, ვინც ამ პროექტს დააყენებთ, გაუკეთეთ მეორე ვარიანტი.",
  AddDevice_button: "დაამატეთ ახალი მოწყობილობა",
  AddDevice_button2: "წვდომის არსებული პროექტი",
  AddNewDevice_title: "დაამატეთ ახალი მოწყობილობა",
  AddNewDevice_text: "ჩვენ გვჭირდება QR კოდი, რომელიც დაბეჭდილია თქვენს მოწყობილობაზე.",
  AddNewDevice_button: "კამერის სკანირება",
  AddNewDevice_button2: "აირჩიეთ ბიბლიოთეკა",
  AddNewDeviceScanQR_title: "კამერის სკანირების რეჟიმი",
  AddNewDeviceScanQR_text: "კამერა მიუთითეთ მოწყობილობებზე QR კოდით. თქვენ უნდა მიანიჭოთ კამერის ნებართვა ამ პროგრამისთვის.",
  AddNewDeviceScanQR_button: "ისევ სკანირება",
  AddNewDeviceScanQR_loading: "გთხოვთ მოიცადოთ...",
  AddNewDeviceScanQR_error: "არასწორი QR კოდი!",
  AddNewDeviceScanQR_NotAllowedError: "შეცდომა! გთხოვთ, დაურთოთ კამერის ნებართვა ამ აპისთვის.",
  AddNewDeviceScanQR_NotFoundError: "შეცდომა! კამერა ვერ მოიძებნა.",
  AddNewDeviceScanQR_NotSupportedError: "შეცდომა! კამერა არ არის მხარდაჭერილი.",
  AddNewDeviceScanQR_NotReadableError: "შეცდომა! კამერა არ იკითხება.",
  AddNewDeviceScanQR_OverconstrainedError: "შეცდომა! შეზღუდვები არ აკმაყოფილებს.",
  AddNewDeviceScanQR_StreamApiNotSupportedError: "შეცდომა! ნაკადი არ არის მხარდაჭერილი.",
  AddNewDeviceUploadQR_button: "აირჩიეთ ფოტო",
  AddNewDeviceUploadQR_title: "აირჩიეთ QR კოდის ფოტო",
  AddNewDeviceUploadQR_text: "გთხოვთ, აირჩიოთ Luxin QR კოდი, რომელიც შეიცავს ფოტოებს.",
  AddNewDeviceUploadQR_alert: "ეს ფოტო არ შეიცავს მოქმედი Luxin QR კოდს. Გთხოვთ კიდევ სცადეთ.",
  AddDeviceNoHub_title: "გაფრთხილება",
  AddDeviceNoHub_text: "თქვენ არ გაქვთ Luxin Hub თქვენს აპლიკაციაში. გთხოვთ, დაუკავშირდეთ ჰაბს.",
  AddNewDeviceDuplicated_title: "უი!",
  AddNewDeviceDuplicated_text: "თქვენ უკვე დაამატეთ ეს მოწყობილობა.",
  AddHub_title: "დაამატეთ კერა",
  AddHub_text: "ეს არის 'Luxin Hub'. გასაგრძელებლად, დააჭირეთ 'შემდეგი'",
  AddHub_button: "შემდეგი",
  AddHubTurnOn_title: "ჩართეთ იგი",
  AddHubTurnOn_text: "შეაერთეთ იგი ენერგიის წყაროსთან და ჩართეთ იგი ღილაკის დენის გამოყენებით.",
  AddHubTurnOn_button: "შემდეგი",
  AddHubLedCheck_title: "Hub- ის LED სტატუსი",
  AddHubLedCheck_text: "Hub- ის LED- ს წითური აქვს და არ ბზინავს?",
  AddHubLedCheck_button: "დიახ",
  AddHubLedCheck_button2: "არა",
  AddHubLedError_title: "უი!",
  AddHubLedError_text: "ამ ჰაბს უკვე აქვს ADMIN. სთხოვეთ ადმინისტრაციას, რომ დაამატოთ როგორც მომხმარებელი. ან შეგიძლიათ გადააკეთოთ ეს ჰაბი, როგორც ახალი.",
  AddHubLedError_button: "გადატვირთვის კერა",
  AddHubLedError_Cancel: "უკან",
  AddHubReset_title: "გადატვირთვის კერა",
  AddHubReset_text:
    "დააჭირეთ გადატვირთვის ღილაკს, რომელიც მდებარეობს ზურგზე მცირე ხვრელის უკან. ADMIN შესაცვლელად, დააჭირეთ ღილაკს სანამ Hub- ის LED- ით ანათებს წითელს / ლურჯს და გაათავისუფლეთ. FACTORY RESET– სთვის, ნუ გამოუშვებთ სანამ LED სწრაფად აანთებს.",
  AddHubReset_button: "შემდეგი",
  AddHubSecurity_title: "უსაფრთხოების პარამეტრები",
  AddHubSecurity_text: "თქვენ შეგიძლიათ გამოიყენოთ ორი ფაქტორიანი ავტორიზაცია, თქვენს კერაზე პაროლის დაყენებით, მაქსიმალური უსაფრთხოების უზრუნველსაყოფად.",
  AddHubSecurity_button: "აირჩიეთ პაროლი",
  AddHubSecurity_button2: "მე არ მჭირდება პაროლი!",
  AddHubSetPassword_title: "ორი ფაქტორი ავტორი.",
  AddHubSetPassword_placeHolder: "პაროლი",
  AddHubSetPassword_placeHolder2: "პაროლის დადასტურება",
  AddHubSetPassword_text: "ეს არ არის თქვენი ანგარიშის პაროლი. ეს არის ამ ჰაბის პაროლი !.",
  AddHubSetPassword_button: "შემდეგი",
  AddHubSetPassword_alert_passwordEmpty: "გთხოვთ, შეიყვანოთ პაროლი!",
  AddHubSetPassword_alert_passwordNotMatch: "პაროლის დადასტურება არ შეესაბამება პაროლს!",
  AddHubNameColor_title: "ჰაბის შექმნა",
  AddHubNameColor_text: "გთხოვთ, აირჩიოთ სახელი და ფერი თქვენი ჰაბისთვის.",
  AddHubNameColor_placeHolder: "სახელი (სახლი, ოფისი, ...)",
  AddHubNameColor_button: "შემდეგი",
  AddHubNameColor_alert_nameEmpty: "გთხოვთ, შეიყვანოთ სახელი თქვენი ჰაბისთვის",
  AddHubConnectWifi_title: "დაკავშირება ჰაბთან",
  AddHubConnectWifi_text: "გთხოვთ, წახვიდეთ თქვენი ტელეფონის Wi-Fi პარამეტრებზე და დაუკავშირდეთ შემდეგ ქსელს. შემდეგ დაუბრუნდით ამ აპლიკაციას და აირჩიეთ 'დაკავშირება ჰაბთან'.",
  AddHubConnectWifi_button: "დაკავშირება ჰაბთან",
  AddHubNotFound_Cancel: "გაუქმება",
  AddHubNotFound_title: "კავშირის შეცდომა!",
  AddHubNotFound_text: "სამწუხაროდ, თქვენს კერასთან დაკავშირებასთან დაკავშირებით პრობლემა შეიქმნა. გთხოვთ დარწმუნდეთ, რომ თქვენ უკავშირდებით Hub- ის Wi-Fi ქსელს და შემდეგ კვლავ სცადეთ.",
  AddHubNotFound_button: "კიდევ სცადე",
  AddHubSuccess_title: "წარმატება",
  AddHubSuccess_text: "თქვენი Luxin Hub წარმატებით დაემატა თქვენს აპს. თქვენ შეგიძლიათ ნახოთ და შეცვალოთ თქვენი ჰაბის პარამეტრები 'მოწყობილობების' ჩანართში.",
  AddHubSuccess_button: "დასრულება",
  AddNode2_title: "განათების ორმაგი შეცვლა",
  AddNode2_text: "თქვენ დაათვალიერეთ განათების ორმაგი შეცვლა. დააჭირეთ შემდეგ, რომ დაამატეთ ეს მოწყობილობა თქვენს ჭკვიან სახლში.",
  AddNode2_button: "შემდეგი",
  AddNode3_title: "განათების ერთი შეცვლა",
  AddNode3_text: "თქვენ დაათვალიერეთ განათების ერთი შეცვლა. დააჭირეთ შემდეგ, რომ დაამატეთ ეს მოწყობილობა თქვენს ჭკვიან სახლში.",
  AddNode3_button: "შემდეგი",
  AddNode4_title: "განათება Multiway შეცვლა",
  AddNode4_text: "თქვენ დაათვალიერეთ განათების მულტივაიანი შეცვლა. დააჭირეთ შემდეგ, რომ დაამატეთ ეს მოწყობილობა თქვენს ჭკვიან სახლში.",
  AddNode4_button: "შემდეგი",
  AddNode5_title: "ზოგადი დანიშნულების შეცვლა",
  AddNode5_text: "თქვენ დაათვალიერეთ ზოგადი დანიშნულების შეცვლა. დააჭირეთ შემდეგ, რომ დაამატეთ ეს მოწყობილობა თქვენს ჭკვიან სახლში.",
  AddNode5_button: "შემდეგი",
  AddNode6_title: "ტემპერატურა-ტენიანობის სენსორი",
  AddNode6_text: "თქვენ დაათვალიერეთ ტემპერატურის და ტენიანობის სენსორი. დააჭირეთ შემდეგ, რომ დაამატეთ ეს მოწყობილობა თქვენს ჭკვიან სახლში.",
  AddNode6_button: "შემდეგი",
  AddNodeSelectHub_title: "აირჩიეთ კერა",
  AddNodeSelectHub_text: "გთხოვთ, აირჩიოთ კერა, რომელიც უნდა შეარჩიოთ ამ მოწყობილობას.",
  AddNodeNameColor_title: "მოწყობილობის შეცვლა",
  AddNodeNameColor_text: "გთხოვთ, აირჩიოთ სახელი და ფერი ამ მოწყობილობისთვის.",
  AddNodeNameColor_button: "დამატება",
  AddNodeNameColor_placeHolder: "სახელი (Bedroon, სამზარეულო, ...)",
  AddNodeNameColor_alert_nameEmpty: "გთხოვთ, შეიყვანოთ სახელი ამ მოწყობილობისთვის",
  AddNodeNameColor_alert_duplicateNode: "ეს მოწყობილობა უკვე დაემატა!",
  AddNodeSuccess_title: "წარმატება",
  AddNodeSuccess_text: "ეს მოწყობილობა წარმატებით დაემატა თქვენს ჭკვიან სახლს. მისი გამოყენების დასაწყებად, დაყავით ის თქვენს ცენტრთან ერთად 'მოწყობილობების' ჩანართში.",
  AddNodeSuccess_button: "დასრულება",
  AddNodeHubNotFound_title: "კავშირის შეცდომა!",
  AddNodeHubNotFound_text: "სამწუხაროდ, თქვენს კერასთან დაკავშირებასთან დაკავშირებით პრობლემა შეიქმნა. გთხოვთ დარწმუნდეთ, რომ თქვენ უკავშირდებით Hub- ის Wi-Fi ქსელს და შემდეგ კვლავ სცადეთ.",
  AddNodeHubNotFound_button: "კიდევ სცადე",
  PairNode_title: "წყვილი მოწყობილობა",
  PairNode_text: "თქვენ უნდა დააწყოთ ეს მოწყობილობა Hub- ით. სანამ დააჭირეთ ღილაკს 'წყვილი', დარწმუნდით, რომ თქვენი Hub ჩართულია და უკავშირდება თქვენს აპს.",
  PairNode_button: "წყვილი",
  PairNode_button2: "მოწყობილობის წაშლა",
  PairNodeSuccess_title: "წარმატება",
  PairNodeSuccess_text: "ეს მოწყობილობა წარმატებით არის დაწყვილებული თქვენი Hub- თან და მზად არის გამოსაყენებლად.",
  PairNodeSuccess_button: "დასრულება",
  PairNodeHubNotResponding_title: "კავშირის შეცდომა!",
  PairNodeHubNotResponding_text: "სამწუხაროდ, თქვენს კერასთან დაკავშირებასთან დაკავშირებით პრობლემა შეიქმნა. გთხოვთ დარწმუნდეთ, რომ თქვენ უკავშირდებით Hub- ის Wi-Fi ქსელს და შემდეგ კვლავ სცადეთ.",
  PairNodeHubNotResponding_button: "კიდევ სცადე",
  PairNodeNodeNotResponding_title: "მოწყობილობის კავშირის შეცდომა!",
  PairNodeNodeNotResponding_text: "თქვენი ჰაბი ვერ შეძლებს ამ მოწყობილობასთან კომუნიკაციას. გთხოვთ დარწმუნდეთ, რომ მოწყობილობა ჩართულია.",
  PairNodeNodeNotResponding_button: "კიდევ სცადე",
  Node2Settings_title1: "მოწყობილობის შეცვლა",
  Node2Settings_title2: "ინფორმაცია მოწყობილობის შესახებ",
  Node2Settings_title3: "ნაგულისხმევი რეჟიმები",
  Node2Settings_button: "ცვლილებების შენახვა",
  Node2Settings_button2: "მოწყობილობის წაშლა",
  Node2Settings_text1: "სახელი",
  Node2Settings_default1: "იგივე ჩვეულებრივ ღიაა",
  Node2Settings_default2: "იგივე ნორმალურად დახურულია",
  Node2Settings_default3: "ჯვარი ჩვეულებრივ ღიაა",
  Node2Settings_default4: "ჯვარი ჩვეულებრივ დახურულია",
  Node3Settings_default1: "ჩვეულებრივ ღიაა",
  Node3Settings_default2: "ჩვეულებრივ დახურულია",
  Node4Settings_default1: "მულტივერის შეყვანა",
  Node2Settings_deviceStatus: "სტატუსი",
  Node2SettingsHubNotResponding_title: "კავშირის შეცდომა!",
  Node2SettingsHubNotResponding_text:
    "სამწუხაროდ, თქვენს კერასთან დაკავშირებასთან დაკავშირებით პრობლემა შეიქმნა. გთხოვთ დარწმუნდეთ, რომ თქვენ უკავშირდებით Hub- ის Wi-Fi ქსელს და შემდეგ კვლავ სცადეთ.",
  Node2SettingsHubNotResponding_button: "უკან",
  Node2SettingsSuccess_title: "წარმატება",
  Node2SettingsSuccess_text: "ახალი პარამეტრები წარმატებით შეინახება თქვენს მოწყობილობაში.",
  Node2SettingsSuccess_button: "უკან",
  Node2SettingsNodeNotResponding_title: "მოწყობილობის კავშირის შეცდომა!",
  Node2SettingsNodeNotResponding_text: "თქვენი ჰაბი ვერ შეძლებს ამ მოწყობილობასთან კომუნიკაციას. გთხოვთ დარწმუნდეთ, რომ მოწყობილობა ჩართულია.",
  Node2SettingsNodeNotResponding_button: "უკან",
  Node2Settings_alert: "გთხოვთ, შეიყვანოთ სახელი ამ მოწყობილობისთვის.",
  DeleteDevice_title: "გაფრთხილება!",
  DeleteDevice_text: "თქვენ აპირებთ ამ მოწყობილობის წაშლას. კიდევ ერთხელ რომ დაამატოთ, თქვენ უნდა დააწეროთ QR კოდი მის ეტიკეტზე. Დარწმუნებული ხარ?",
  DeleteDevice_button: "დიახ",
  DeleteDevice_button2: "არა",
  DeleteDeviceSuccess_title: "წარმატება",
  DeleteDeviceSuccess_text: "მოწყობილობა წარმატებით წაშლილია თქვენი ჭკვიანი სახლიდან.",
  DeleteDeviceSuccess_button: "უკან",
  RelaySSR2ASettings_title1: "გამომავალი",
  RelaySSR2ASettings_text1: "გამომავალი სახელმწიფო",
  RelaySSR2ASettings_switchState_On: "ჩართული",
  RelaySSR2ASettings_switchState_Off: "გამორთულია",
  RelaySSR2ASettings_title2: "გამოყვანის პარამეტრები",
  RelaySSR2ASettings_text2: "გამომავალი ტიპი",
  RelaySSR2ASettings_text3: "სახელი",
  RelaySSR2ASettings_text4: "საწყისი სახელმწიფო",
  RelaySSR2ASettings_button: "ცვლილებების შენახვა",
  RelaySSR2ASettings_initState1: "ჩართული",
  RelaySSR2ASettings_initState2: "გამორთულია",
  RelaySSR2ASettings_outputType1: "განათება",
  RelaySSR2ASettings_outputType2: "მორწყვა",
  RelaySSR2ASettings_outputType3: "ქულერი",
  RelaySSR2ASettings_outputType4: "გამათბობელი",
  RelaySSR2ASettings_outputType5: "კარი",
  RelaySSR2ASettings_alert: "გთხოვთ, შეიტანოთ სახელი ამ გამომავალი პროდუქტისთვის.",
  ZeroContactSettings_title1: "შეყვანა",
  ZeroContactSettings_text1: "შეყვანის სახელმწიფო",
  ZeroContactSettings_title2: "შეყვანის პარამეტრები",
  ZeroContactSettings_text2: "შეყვანის ტიპი",
  ZeroContactSettings_inputType1: "ნორმალური შეცვლა",
  ZeroContactSettings_inputType2: "დააჭირეთ ღილაკს",
  ZeroContactSettings_inputType3: "კვამლის დეტექტორი",
  ZeroContactSettings_inputType4: "ყოფნის დეტექტორი",
  ZeroContactSettings_text3: "შეყვანის სახელი",
  ZeroContactSettings_text4: "მიმართულება",
  ZeroContactSettings_alert: "გთხოვთ, შეიყვანოთ სახელი ამ შეტანისთვის.",
  ZeroContactSettings_button: "ცვლილებების შენახვა",
  ZeroContactSettings_text5: "გავლენა",
  HubSettings_title1: "მოწყობილობის შეცვლა",
  HubSettings_text1: "სახელი",
  HubSettings_title2: "მართეთ ჰაბი",
  HubSettings_button: "ცვლილებების შენახვა",
  HubSettings_button2: "წაშალეთ კერა",
  HubSettings_alert: "გთხოვთ, მიუთითოთ სახელი ამ ჰაბისთვის.",
  HubSettings_title3: "სტატუსი",
  HubSettings_button3: "განახლება firmware",
  HubSettings_button4: "მართეთ მომხმარებლები",
  HubSettings_button5: "მართეთ Wi-Fi ქსელი",
  DeleteHub_title: "წაშალეთ კერა",
  DeleteHub_text:
    "თქვენ აპირებთ ამ ჰაბის წაშლას. თუ გააგრძელებთ, ამ კერასთან დაკავშირებული ყველა მოწყობილობა ასევე წაშლილია თქვენი აპკიდან. თქვენ გჭირდებათ ამ ჰაბის UUID და მისი პაროლის გამოყენება, რომ მას ისევ დაუკავშირდეთ. Დარწმუნებული ხარ?",
  DeleteHub_button: "დიახ",
  DeleteHub_button2: "არა",
  OTA_title: "Firmware განახლება",
  OTA_text:
    "ამით თქვენ განაახლებთ ჰაბის პროგრამულ უზრუნველყოფას უახლეს ვერსიაში. დარწმუნდით, რომ თქვენი ჰაბი არის ინტერნეტით და სტაბილური ელექტრომომარაგებით. ნუ მიირთმევთ თქვენს კერას პროცესებს. დარწმუნებული ხართ, რომ გსურთ გაგრძელება?",
  OTA_button: "დიახ",
  OTA_button2: "არა",
  OtaSuccess_title: "წარმატება",
  OtaSuccess_text: "თქვენი ჰაბის firmware განახლებულია. გთხოვთ, არ გამორთოთ კერა და დაელოდოთ კერის LED- ს, რომ სწრაფად შეწყვიტოთ მოციმციმე. შემდეგ გადატვირთეთ იგი.",
  OtaSuccess_button: "შესრულებულია",
  HubNetworkSettings_title: "ქსელის პარამეტრები",
  HubNetworkSettings_text1: "ქსელის ტიპი",
  HubNetworkSettings_text2: "WiFi სახელი (SSID)",
  HubNetworkSettings_text3: "Wi-Fi პაროლი",
  HubNetworkSettings_alert: "თქვენი მოთხოვნა ვერ შესრულდა. გთხოვთ კიდევ სცადეთ.",
  HubNetworkSettings_button: "ცვლილებების შენახვა",
  HubNetworkSettings_alert2: "გთხოვთ, შეიყვანოთ ქსელის სახელი.",
  HubNetworkSettingsSuccess_title: "წარმატება",
  HubNetworkSettingsSuccess_text: "წარმატებით შეიცვალა ჰაბის Wi-Fi ქსელი. გთხოვთ, შეცვალოთ თქვენი ტელეფონის WiFi პარამეტრი და დაუკავშირდით იგივე ქსელს, როგორც Hub- ს.",
  HubNetworkSettingsSuccess_button: "შესრულებულია",
  HubUserSettings_title: "მომხმარებლები",
  HubUserSettings_button: "დაამატეთ ახალი მომხმარებელი",
  EditUser_title1: "მომხმარებლის შეცვლა",
  EditUser_text1: "მობილური Numebr",
  EditUser_text2: "დაშვების დონე",
  EditUser_text3: "მომხმარებლის სახელი",
  EditUser_button1: "მომხმარებლის წაშლა",
  EditUser_button2: "ცვლილებების შენახვა",
  EditUser_alert: "გთხოვთ, შეიყვანოთ სახელი ამ მომხმარებლისთვის.",
  EditUser_ownerText: "ადმინ",
  EditUser_normalText: "მომხმარებელი",
  AddNewUser_title: "დაამატეთ ახალი მომხმარებელი",
  AddNewUser_text: "ახალი მომხმარებლის დამატება, გთხოვთ, შეიყვანოთ მობილური ტელეფონის ნომერი და ახალი მომხმარებლის სახელი.",
  AddNewUser_placeHolder: "მობილურის ნომერი",
  AddNewUser_placeHolder2: "სახელი",
  AddNewUser_button: "დაამატეთ ახალი მომხმარებელი",
  AddNewUser_alert1: "გთხოვთ, შეიყვანოთ ახალი მომხმარებლის მობილური ნომერი.",
  AddNewUser_alert2: "გთხოვთ, შეიყვანოთ ახალი მომხმარებლის სახელი.",
  AddNewUser_alert3: "მომხმარებელი უკვე დარეგისტრირდა.",
  AddNewUser_serverResponseFail: "მოთხოვნა ვერ განხორციელდა. გთხოვთ, შეამოწმოთ მობილური ნომერი და სცადეთ ხელახლა.",
  NewUserCredentials_title: "ახალი მომხმარებელი",
  NewUserCredentials_text:
    "ახალი მომხმარებელი წარმატებით დაემატა თქვენს კერას. მათ შეუძლიათ შეხვიდეთ თქვენს ჰაბში, ამ სერთიფიკატების შეტანის გზით. გთხოვთ, შეინახოთ ეს გვერდი და გაუგზავნოთ ახალ მომხმარებელს.",
  NewUserCredentials_button: "დასრულება",
  DeleteUser_title: "მომხმარებლის წაშლა",
  DeleteUser_text: "დარწმუნებული ხართ, რომ გსურთ წაშალოთ ეს მომხმარებელი თქვენი ჰაბიდან?",
  DeleteUser_button: "დიახ",
  DeleteUser_button2: "არა",
  HubLogin_title: "დაკავშირება ჰაბთან",
  HubLogin_text: "გთხოვთ, დარწმუნდეთ, რომ თქვენ იმყოფებით იგივე Wi-Fi ქსელში, როგორც Hub's, და შეიყვანეთ თქვენი ავტორიზაციის სერტიფიკატები, რომლებიც მოცემულია ამ კერის ადმინისტრატორის მიერ.",
  HubLogin_placeHolder: "UUID",
  HubLogin_placeHolder2: "პაროლი",
  HubLogin_button: "დაკავშირება",
  HubLogin_alert1: "გთხოვთ, შეიყვანოთ UUID ცენტრი.",
  HubLogin_alert2: "გთხოვთ შეიყვანეთ თქვენი პაროლი.",
  HubLogin_alert3: "თქვენ უკვე ხართ დაკავშირებული ამ კერასთან.",
  HubLoginSuccess_title: "წარმატება",
  HubLoginSuccess_text: "თქვენ ახლა ხართ დაკავშირებული ამ კერასთან.",
  HubLoginSuccess_button: "დასრულება",
  HubLoginNotFound_title: "სისტემაში შესვლა ვერ მოხერხდა",
  HubLoginNotFound_text: "აპს არ შეუძლია დაუკავშირდეს ამ ჰაბს. გთხოვთ დარწმუნდეთ, რომ უკავშირდებით იმავე Wi-Fi ქსელს და შეამოწმეთ UUID ველი.",
  HubLoginNotFound_button: "კიდევ სცადე",
  HubLoginError_title: "სისტემაში შესვლა ვერ მოხერხდა",
  HubLoginError_text: "თქვენი პაროლი უარყო ამ კერამ. გთხოვთ, სცადოთ კიდევ ერთხელ ან დაუკავშირდეთ ჰაბის ადმინისტრაციას.",
  HubLoginError_button: "კიდევ სცადე",
  MainMenu_title: "მთავარი მენიუ",
  MainMenu_button1: "ენის არჩევა",
  MainMenu_button2: "გამოსვლა",
  LogOut_title: "გამოსვლა",
  LogOut_text: "დარწმუნებული ხართ, რომ გსურთ სისტემიდან გამოსვლა?",
  LogOut_button: "დიახ",
  LogOut_button2: "არა",
  TemperatureSensorSettings_title1: "შეყვანა",
  TemperatureSensorSettings_text1: "ტემპერატურა",
  TemperatureSensorSettings_title2: "შეყვანის პარამეტრები",
  TemperatureSensorSettings_text3: "შეყვანის სახელი",
  TemperatureSensorSettings_button: "ცვლილებების შენახვა",
  HumiditySensorSettings_title1: "შეყვანა",
  HumiditySensorSettings_text1: "ტენიანობა",
  HumiditySensorSettings_title2: "შეყვანის პარამეტრები",
  HumiditySensorSettings_text3: "შეყვანის სახელი",
  HumiditySensorSettings_button: "ცვლილებების შენახვა",
  DashBoard_noWidgets: "ვიჯეტები არ მოიძებნა.",
  Dashboard_editWidgets: "რედაქტირება",
  DashBoard_addWidget: "ახალი ვიჯეტის დამატება",
  Dashboard_doneEditing: "დამახსოვრება",
  LuxinWidget_singleSwitch: "ერთჯერადი შეცვლა",
  DeleteWidget_title: "ვიჯეტის ამოღება",
  DeleteWidget_text: "დარწმუნებული ხართ, რომ გსურთ ამ ვიჯეტის წაშლა?",
  DeleteWidget_button: "დიახ",
  DeleteWidget_button2: "არა",
  Scenarios_addScenario: "სცენის დამატება",
  Scenarios_noscenario: "არცერთი სცენა არ მოიძებნა.",
  AddScenario_title1: "სცენის შეცვლა",
  AddScenario_text1: "სახელი",
  Scenario_namePlaceHolder: "სცენის სახელი",
  AddScenario_button: "დამახსოვრება",
  AddScenario_alert1: "Please enter a name for this scene.",
  Scenarios_scenarioCommonName: "სცენა",
  EditScenario_deleteButton: "სცენის წაშლა",
  EditScenario_text5: "კერა",
  DeleteScenario_title: "სცენის წაშლა",
  DeleteScenario_text: "დარწმუნებული ხართ, რომ გსურთ ამ სცენის წაშლა?",
  DeleteScenario_button: "დიახ",
  DeleteScenario_button2: "არა",
  EditWidget_title1: "ვიჯეტის პერსონალურად შექმნა",
  Name_text: "სახელი",
  WidgetName_PlaceHolder: "ვიჯეტის სახელი",
  SaveChanges_button: "ცვლილებების შენახვა",
  Output_text: "გამომავალი",
  ChooseHub_text: "აირჩიეთ კერა",
  ChooseOutput_text: "აირჩიეთ გამოსავალი",
  WidgetName_alert: "გთხოვთ, შეიყვანოთ ვიჯეტის სახელი.",
  AddNewWidget_button: "დამატება",
  AddNewWidget_singleSwitchDescription: "ერთი შეცვლა, რომ აკონტროლოთ ჩართვა / გამორთვის შედეგები პირდაპირი უკუკავშირის საშუალებით.",
  Save_button: "დამახსოვრება",
  TemperatureSensorSettings_title3: "პირობები",
  TemperatureSensorSettings_unknownScenario: "უცნობი სცენარი",
  TemperatureSensorSettings_title4: "დაამატეთ მდგომარეობა",
  TemperatureSensorSettings_rising: "უმაღლესი ხდება",
  TemperatureSensorSettings_falling: "ქვედა",
  TemperatureSensorSettings_text2: "მდგომარეობის ტიპი",
  TemperatureSensorSettings_text4: "აირჩიეთ სცენარი",
  TemperatureSensorSettings_button2: "დაამატეთ მდგომარეობა",
  TemperatureSensorSettings_button3: "პირობების შენახვა",
  TemperatureSensorSettings_button4: "დაამატეთ სცენარი",
  HubSettings_title4: "მონაცემთა ბაზა",
  HubSettings_button6: "სინქრონიზაციის მონაცემთა ბაზა",
  HubSettings_button7: "მონაცემთა ბაზის შენახვა",
  DeleteUser_serverError: "სერვერის შეცდომა. გთხოვთ სცადოთ მოგვიანებით.",
  HubSettings_serverError: "სერვერის შეცდომა. გთხოვთ სცადოთ მოგვიანებით.",
  HubSettings_noSnapshotsFound: "არცერთი სურათი არ მოიძებნა.",
  AddNewWidget_sceneButtonDescription: "ღილაკი თქვენი პერსონალური სცენის გასაშვებად.",
  LuxinWidget_sceneButton: "სცენის ღილაკი",
  SceneButton_runScene: "გარბოდა",
  AddSceneButtonWidget_button: "დამახსოვრება",
  EditSceneButtonWidget_button: "დამახსოვრება",
  DeleteDevice_alert: "თქვენ არ გაქვთ წვდომა ამ ქმედებაზე.",
  Node2Settings_default5: "იგივე Toggle",
  Node2Settings_default6: "ჯვრის შეცვლა",
  Node3Settings_default3: "Toggle",
  HubNetworkSettings_alert3: "გთხოვთ, შეიყვანოთ ქსელის პაროლი.",
  AddNewDeviceUploadQR_alert2: "ფოტოში არ არის QR კოდი.",
  AddNewDeviceUploadQR_alert3: "თქვენი QR კოდის სკანირებისას წარმოიშვა პრობლემა.",
  AddNode7_title: "IR Controller",
  AddNode7_text: "You've scanned an IR Controller. Hit next to add this device to your smart home.",
  AddNode7_button: "Next",
  NODE7_INPUT1_NAME: "Temperature",
  NODE7_INPUT2_NAME: "Humidity",
  Node7Settings_IrDevice: "IR Device",
  Node7Settings_addIrDevice: "Add IR Device",
  AddIrDevice_title1: "Customize",
  AddIrDevice_text1: "Name",
  AddIrDevice_namePlaceHolder: "IR Device Name",
  AddIrDevice_button: "Save",
  AddIrDevice_title2: "Select Device",
  AddIrDevice_text2: "Device Type",
  AddIrDevice_text3: "Brand",
  NODE7_AC_NAME: "Split",
  AddIrDevice_text4: "Model",
  AddIrDevice_testDevice: "Test Device",
  AddIrDevice_text5: "Please point your IR controller to your target device and select 'Test Device'. It your target device reacted, then hit 'Save', if not, try other models.",
  AddIrDevice_alert1: "Please enter device name",
  IrDeviceSettings_button2: "Delete IR Device",
  DeleteIrDevice_title: "Delete Ir Device",
  DeleteIrDevice_text: "Are you sure you want to delete this IR device?",
  DeleteIrDevice_button: "Yes",
  DeleteIrDevice_button2: "No",
  IrDeviceSettings_title3: "Remote Controller",
  IrDeviceSettings_showRemote: "Show Remote Controller",
  AddIrDevice_turnDeviceOff: "Turn Off",
  DashBoard_scehdule: "Schedules",
  weekDays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  weekDaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  AddSchedule_title1: "Customize",
  AddSchedule_text1: "Name",
  AddSchedule_namePlaceHolder: "Schedule Name",
  AddSchedule_text2: "Select Hub",
  AddSchedule_text3: "Hour",
  AddSchedule_text4: "Minute",
  AddSchedule_title2: "Time Select",
  AddSchedule_button: "Save",
  AddSchedule_text5: "Repeat",
  AddSchedule_title3: "Create Command",
  AddSchedule_button2: "Add Scene",
  AddSchedule_alert1: "Please enter a name for this schedule.",
  Schedules_schedule: "Schedule",
  Schedules_button: "Add Schedule",
  Schedules_loadError: "Problem loading schedules",
  Schedules_noSchedule: "No Schedules were found",
  Schedules_time: "Time: ",
  Schedules_repeat: "Repeat: ",
  AddScheduleSuccess_title: "Success",
  AddScheduleSuccess_text: "Your schedule has successfully been added to system.",
  AddScheduleSuccess_button: "Finish",
  Schedules_todayOnly: "Today Only",
  DeleteSchedule_title: "Delete Schedule",
  DeleteSchedule_text: "Are you sure you want to delete this schedule?",
  DeleteSchedule_button: "Yes",
  DeleteSchedule_button2: "No",
  Schedules_alert: "You have no hubs installed.",
  RelaySSR2ASettings_switchState_Unknown: "Loading...",
  CommandCreator_title2: "Commands",
  CommandCreator_title3: "Create Command",
  CommandCreator_text2: "Output Select",
  CommandCreator_text3: "Output State",
  CommandCreator_text4: "Delay (seconds)",
  CommandCreator_outputStateOn: "ON",
  CommandCreator_outputStateOff: "OFF",
  CommandCreator_outputStateToggle: "Toggle",
  CommandCreator_button2: "Add Command",
  CommandCreator_outputStateTitle: "State",
  CommandCreator_delayTitle: "Delay",
  CommandCreator_delaySecond: "Second(s)",
  CommandCreator_alert2: "Please create at least one command.",
  CommandCreator_text5: "Select Hub",
  CommandCreator_alertNoOutputs: "No outputs found for the selected Hub",
  NoOutPutForHub_alert: "No outputs found for the selected Hub",
  NoInstalledHub_alert: "You don't have any installed Hubs.",
  CommandCreator_alertNoHubs: "You don't have any installed Hubs.",
  CommandCreator_alertPacketOverflow: "Your command length exceeds the limit.",
  CommandCreator_button3: "Create Command",
  AddTemperatureAutomationWidget_title1: "Customize Widget",
  AddTemperatureAutomationWidget_text1: "Name",
  AddTemperatureAutomationWidget_namePlaceHolder: "Widget Name",
  AddTemperatureAutomationWidget_title2: "Automation Settings",
  AddTemperatureAutomationWidget_automationType1: "Heat and Cool",
  AddTemperatureAutomationWidget_automationType2: "Cool",
  AddTemperatureAutomationWidget_automationType3: "Heat",
  AddTemperatureAutomationWidget_text2: "Automation Type",
  AddTemperatureAutomationWidget_text3: "Season select",
  AddTemperatureAutomationWidget_targetSeason1: "Summer",
  AddTemperatureAutomationWidget_targetSeason2: "Winter",
  AddTemperatureAutomationWidget_text4: "Temperature Sensor Select",
  AddTemperatureAutomationWidget_text5: "Select Hub",
  AddTemperatureAutomationWidget_cool_on_description: "Please create the command to turn your cooling system on",
  AddTemperatureAutomationWidget_cool_off_description: "Please create the command to turn your cooling system off",
  AddTemperatureAutomationWidget_heat_on_description: "Please create the command to turn your heating system on",
  AddTemperatureAutomationWidget_heat_off_description: "Please create the command to turn your heating system off",
  AddTemperatureAutomationWidget_cool_text: "Cooling Output",
  AddTemperatureAutomationWidget_heat_text: "Heating Output",
  AddTemperatureAutomationWidget_button: "Save",
  AddTemperatureAutomationWidget_alertNoSensor: "No temperature sensor found in your selected hub.",
  AddTemperatureAutomationWidget_alertCoolOnNoCommand: "Please create the command to turn your cooling system on",
  AddTemperatureAutomationWidget_alertCoolOffNoCommand: "Please create the command to turn your cooling system off",
  AddTemperatureAutomationWidget_alertHeatOnNoCommand: "Please create the command to turn your heating system on",
  AddTemperatureAutomationWidget_alertHeatOffNoCommand: "Please create the command to turn your heating system off",
  AddTemperatureAutomationWidget_alertHubFailed: "Error connecting to target Hub. Please make sure you are connected to target Hub.",
  AddTemperatureAutomationWidget_alertSensorFailed: "Error connecting to temperature sensor. Your automation is added but please make sure your temperature sensor is turned on.",
  LuxinWidget_temperatureAutomation: "Temperature Automation",
  TemperatureAutomationWidget_alertSensorFailed: "Operation was successful but please make sure your temperature sensor is turned on.",
  EditSingleSwitchWidget_alertNotSync: "Could not load commands because your app is not synced. Please sync your database.",
  AddNewWidget_temperatureAutomationDescription: "Full control over cooling and heating systems",
  AddTemperatureAutomationWidget_alertNotOwner: "Sorry, Only Hub's owner can set automations.",
  EditTemperatureAutomationWidget_alertNotOwner: "Sorry, Only Hub's owner can edit automations.",
  DeleteTemperatureAutomation_title: "Delete Temperature Automation",
  DeleteTemperatureAutomation_text: "Are you sure you want to delete this automation? After deleting, this automation will no longer function.",
  DeleteTemperatureAutomation_button: "Yes",
  DeleteTemperatureAutomation_button2: "No",
  DeleteTemperatureAutomation_alertNotOwner: "Sorry, Only Hub's owner can delete automations.",
  DeleteTemperatureAutomation_alertDeleteError: "Oops, something went wrong.",
  DeleteTemperatureAutomation_alertSensorFailed: "Error connecting to your temperature sensor. Your automation is deleted but please make sure your temperature sensor is turned on.",
  HubNetworkSettings_alert4: "Password should be at lesat 8 characters.",
  Schedules_commands: "Commands: ",
  Schedules_showCommands: "Show Comamnds",
  AddSchedule_alert5: "You should create a command for this schedule.",
  AddSchedule_alert6: "You cannot add more schedules.",
  DeleteSchedule_alertDeleteError: "Oops, something went wrong.",
  Schedules_everyDay: "Everyday",
  AddSchedule_text6: "Next Occurrence",
  AddSchedule_button3: "Delete",
  AddNode9_title: "RGBW Controller",
  AddNode9_text: "You've scanned an RGBW Controller. Hit next to add this device to your smart home.",
  AddNode9_button: "Next",
  NODE9_INPUT1_NAME: "Input 1",
  NODE9_OUTPUT1_NAME: "RGB",
  NODE9_OUTPUT2_NAME: "Red",
  NODE9_OUTPUT3_NAME: "Green",
  NODE9_OUTPUT4_NAME: "Blue",
  NODE9_OUTPUT5_NAME: "White",
  Node9Settings_hue: "HUE",
  Node9Settings_rgbw: "RGBW",
  Node9Settings_rgb: "RGB",
  Node9Settings_red: "Red",
  Node9Settings_green: "Green",
  Node9Settings_blue: "Blue",
  Node9Settings_white: "White",
  Node9Settings_alert1: "Hub Connection Error!",
  Node9Settings_fadeTime: "Fade Time (ms)",
  Node9Settings_animation: "Animation",
  Node9Settings_animation0: "Disabled",
  Node9Settings_animation1: "Random",
  Node9Settings_animation2: "HUE Circle",
  Node9Settings_default: "Default Color",
  Node2Settings_setAsDefault: "Set as default color",
  Node9Settings_colorPickerType: "Color Palette",
  LuxinWidget_RGBW: "RGBW Controller",
  AddNewWidget_rgbwDescription: "A Color Palette to control your RGBW strip.",
  AddRGBWWidget_button: "Save",
  HubSettings_title5: "Voice Assistant",
  HubSettings_button8: "Amazon Alexa",
};
